var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm.message
        ? _c(
            "div",
            { staticClass: "notification is-light", class: _vm.messageType },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.email.$error,
            required: _vm.$v.email.required,
            label: "Email",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.email.$model,
                expression: "$v.email.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.email.$error },
            attrs: { type: "text" },
            domProps: { value: _vm.$v.email.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.$v.email, "$model", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          !_vm.$v.email.email
            ? _c("p", { staticClass: "help is-danger" }, [
                _vm._v(" We require a valid email address "),
              ])
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "buttons mt-5" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary is-fullwidth",
            class: { "is-loading": _vm.fetching },
            attrs: { disabled: !_vm.isValid },
          },
          [_vm._v(" Reset link ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }